const fromReactElementToCopyable = symbol => {
  // If it's an anchor tag, return the href.
  if (symbol?.type === 'a') {
    return symbol?.props?.href;
  }

  // If it's an image, return the src.
  if (symbol?.type === 'img') {
    return symbol?.props?.src;
  }

  // Use textContent for a safer way to decode HTML entities and prevent XSS
  const value = symbol?.props?.children;
  const decoded = document.createElement('textarea');
  decoded.textContent = value; // Safely sets the text without parsing HTML
  return decoded.value; // Correctly use textContent
};

export default fromReactElementToCopyable;
